import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import {
  Database,
  equalTo,
  listVal,
  orderByChild,
  query,
  ref,
  push,
  set,
  get,
} from "@angular/fire/database";
import {
  Observable,
  catchError,
  from,
  map,
  of,
  switchMap,
  take,
  tap,
  throwError,
} from "rxjs";
import { IEmpresa } from "../../../interfaces/catalogos.";
import { IREmpresas } from "../../../interfaces/empresas";
import { environment } from "../../../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class EmpresaService {
  private database: Database = inject(Database);

  constructor(private http: HttpClient) {}


  cargarEmpresas(): Observable<IEmpresa[]> {
    const refCatalogo = ref(this.database, "catalogos/empresa");
    const refQuery = query(refCatalogo, orderByChild("activo"), equalTo(true));
    return listVal(refQuery, { keyField: "id" }).pipe(
      map((empresas: unknown[]) => {
        const usuariosTyped = empresas as IEmpresa[];
        return usuariosTyped.sort((a, b) =>
          a.descripcion.localeCompare(b.descripcion)
        );
      })
    );
  }

  guardarEmpresa(descripcion: string): Observable<{ error: boolean }> {
    const refCatalogo = ref(this.database, "catalogos/empresa");
    const nuevaEmpresaRef = push(refCatalogo);
    const nuevaEmpresa: IEmpresa = {
      activo: true,
      descripcion,
      id: nuevaEmpresaRef.key || "",
    };

    return from(set(nuevaEmpresaRef, nuevaEmpresa)).pipe(
      map(() => ({ error: false })),
      catchError((error) => {
        console.error(error);
        return of({ error: true });
      })
    );
  }

  editarEmpresa(empresa: IEmpresa): Observable<{ error: boolean }> {
    const refEmpresa = ref(this.database, `catalogos/empresa/${empresa.id}`);

    return from(get(refEmpresa)).pipe(
      switchMap((empresaSnapshot) => {
        if (empresaSnapshot.exists()) {
          const nuevaEmpresa = empresaSnapshot.val();
          nuevaEmpresa.descripcion = empresa.descripcion;
          return from(set(refEmpresa, nuevaEmpresa)).pipe(
            map(() => ({ error: false }))
          );
        } else {
          return throwError(() => new Error("La empresa no existe."));
        }
      }),
      catchError((error) => {
        console.error(error);
        return of({ error: true });
      })
    );
  }

  eliminarEmpresa(id: string): Observable<{ error: boolean }> {
    const refEmpresa = ref(this.database, `catalogos/empresa/${id}`);

    return from(get(refEmpresa)).pipe(
      switchMap((empresaSnapshot) => {
        if (empresaSnapshot.exists()) {
          const nuevaEmpresa = empresaSnapshot.val();
          nuevaEmpresa.activo = false;
          return from(set(refEmpresa, nuevaEmpresa)).pipe(
            map(() => ({ error: false }))
          );
        } else {
          return throwError(() => new Error("La empresa no existe."));
        }
      }),
      catchError((error) => {
        console.error(error);
        return of({ error: true });
      })
    );
  }

  getEmpresas(): Observable<IREmpresas> {
    return this.http
      .get<IREmpresas>(`${environment.catalogos.getCatalogo}empresa`)
      .pipe(
        tap((data) => console.log("API Response", data)),
        take(1),
        map((data: IREmpresas) => {
          return data;
        }),
        catchError((error: any) => {
          console.error("Error en detalleAcuerdo", error);
          return of({ error: true, empresas: [] } as unknown as IREmpresas);
        })
      );
  }
  consultarTemasPorEmpresa(idEmpresa: string): Observable<any> {
    return this.http
      .get<IREmpresas>(
        `${environment.despacho.consultarTemasPorEmpresa}/${idEmpresa}`
      )
      .pipe(
        tap((data) => console.log("API Response", data)),
        take(1),
        map((data) => {
          return data;
        }),
        catchError((error: any) => {
          console.error("Error en consultarTemasPorEmpresa", error);
          return of({ error: true, temas: [] });
        })
      );
  }
}
